export default __webpack_public_path__ + "static/cover-blank-72ce5643992bec029583ee5912a6fdd9.jpg";